import Vue from 'vue'
import Snake from './Snake.vue'

// Vue.component(GlobalEvents)

Vue.config.productionTip = false

new Vue({
  render: h => h(Snake),
}).$mount('#app')
